import { useState } from "react";
export default function StatsPage({tasks}){
   return <div>{tasks.filter(task => task.done).length} / {tasks.length}</div>
}